import Swiper from 'swiper'
import { Navigation, Pagination, Thumbs } from 'swiper/modules';
import SideCart from './SideCart';

class ProductInfo extends HTMLElement {
    sidecart = document.querySelector<SideCart>('side-cart');

    constructor() {
        super()
        this.init()
    }

    private init() : void {
        this.handleChangeVariant()
        this.handleStickyChangeSizeSelect()
        this.handleStickyChangeColorInput()
        this.handleStickyWhenScrolling()
        this.initImageZoom()
    }

    updateURL(productInfo: HTMLElement | null) {
        const productUrl = this.dataset.url
        const variantId = productInfo?.dataset.selectedVariant

        console.log(variantId)

        window.history.replaceState({}, '', `${productUrl}${variantId ? `?variant=${variantId}` : ''}`);
    }

    private async getUpdatedSection() {
        const sectionId = this.dataset.section
        const productUrl = this.dataset.url
        const values = this.getSelectedValues()
        const destination = document.getElementById(`shopify-section-${sectionId}`)

        try {
            await fetch(`${productUrl}?section_id=${sectionId}&option_values=${values.toString()}`, {
                method: 'GET'
            })
            .then(response => response.text())
            .then(responseText => {
                if(destination) {
                    destination.innerHTML = responseText
                    const html = new DOMParser().parseFromString(responseText, 'text/html');
                    this.updateURL( html.querySelector('product-info'))
                }
            });
        } catch (error) {
            
        }
    }

    // handle every change on variant selects
    private handleChangeVariant() {
        const inputs = this.querySelectorAll('input.product__variant-input')

        inputs.forEach((input) => {
            input.addEventListener('change', async () =>{
                console.info('input has changed')
                await this.getUpdatedSection()
                this.initAccordions()
                this.initSliders()
                this.sidecart?.initializeAddEvent()
            })
        })
    }

    private handleStickyChangeSizeSelect() {
        const selectSize = this.querySelector<HTMLSelectElement>('.sticky-atc__variant-sizes')

        selectSize?.addEventListener('change', async () =>{
            const sizeToLook = selectSize.options[selectSize.selectedIndex]?.value
            const size = this.querySelector<HTMLInputElement>(`input[value="${sizeToLook}"]`)
            size?.click()
        })
    }

    private handleStickyChangeColorInput() {
        const variantColorInputs = this.querySelectorAll<HTMLInputElement>('.sticky-atc__variant-color-input')

        variantColorInputs.forEach((variantColorInput) => {
            variantColorInput.addEventListener('change', () => {
                const input = this.querySelector<HTMLInputElement>(`.product__variant-input[value="${variantColorInput.value}"]`)
                input?.click()
            })
        })
    }

    private verifyIsVisible (element: HTMLElement): boolean {
        const item = element.getBoundingClientRect()
        return (
            item.top >= 0 &&
            item.left >= 0 &&
            item.bottom <= (
                window.innerHeight ||
                document.documentElement.clientHeight) &&
            item.right <= (
                window.innerWidth ||
                document.documentElement.clientWidth)
        ) 
    }

    private toggleStickyATC (reference: HTMLElement, sticky: HTMLElement) {
        if (this.verifyIsVisible(reference)) {
            sticky.classList.remove('visible')
        } else {
            sticky.classList.add('visible')
        }
    }

    private handleStickyWhenScrolling = () => {
        const stickyATC = this.querySelector<HTMLElement>('.sticky-atc-container')
        const mainProductButtons = this.querySelector<HTMLElement>('.product-form__buttons') || document.createElement('div')
    
        if(!stickyATC) { return }
    
        window.addEventListener('scroll', () => {
            this.toggleStickyATC(mainProductButtons, stickyATC);
        });
    }

    private getSelectedValues() {
        const inputsSelected = this.querySelectorAll('input.product__variant-input:checked')
        let values: (string | null)[] = []
        inputsSelected.forEach((input) => {
            values.push(input.getAttribute('data-option-value-id'))
        })
        return values
    }

    async closingAccordions (parent: any) {
        const accordionsToClose = parent.querySelectorAll(".accordion-js-item.is-open")
        accordionsToClose.forEach((item: any) => {
            console.log(item)
            item.classList.remove("is-open")
            item.querySelector(".accordion-js-toggle").classList.remove("is-open")
            item.querySelector(".accordion-js-content").classList.remove("is-open")
        })
    }
    
    initAccordions() {
        const accordionToggles = document.querySelectorAll(".accordion-js-toggle")
        if (!accordionToggles) { return }
    
        accordionToggles.forEach((accordionToggle) => {
            accordionToggle.addEventListener("click", async () => {
                const accordionContent = accordionToggle.parentElement?.querySelector('.accordion-js-content')
                const accordionItem = accordionToggle.parentElement
    
                await this.closingAccordions(accordionToggle.closest(".accordion-js"))
    
                if (accordionToggle.classList.contains("is-open")) {
                    accordionToggle.classList.remove("is-open")
                    accordionContent?.classList.remove("is-open")
                    accordionItem?.classList.remove("is-open")
                } else { 
                    accordionToggle.classList.add("is-open")
                    accordionContent?.classList.add("is-open")
                    accordionItem?.classList.add("is-open")
                }
            });
        });
    }

    initSliders() {
        const productGalleryThumbs = new Swiper(".product-gallery-thumbs", {
            modules: [Navigation],
            centeredSlides: false,
            centeredSlidesBounds: false,
            slidesPerView: 4,
            watchOverflow: true,
            // watchSlidesVisibility: true,
            watchSlidesProgress: true,
            direction: 'vertical',
            navigation: {
                prevEl: '.product-gallery-thumbs-prev',
                nextEl: '.product-gallery-thumbs-next'
            }
        });
    
        new Swiper(".product-gallery-main", {
            modules: [Navigation, Pagination, Thumbs],
            watchOverflow: true,
            // watchSlidesVisibility: true,
            watchSlidesProgress: true,
            preventInteractionOnTransition: true,
            pagination: {
              el: '.product-gallery-main-pagination'
            },
            effect: 'fade',
              fadeEffect: {
              crossFade: true
            },
            thumbs: {
              swiper: productGalleryThumbs
            }
        });
    }
    
    zoomInWhenMouseMove (e: any) {
        const imagezoom = e.target.closest('.image-zoom-js')
    
        imagezoom.style.setProperty('--display', 'block')
        let pointer = {
            x: (e.offsetX * 100)/imagezoom.offsetWidth,
            y: (e.offsetY * 100)/imagezoom.offsetHeight
        }
        imagezoom.style.setProperty('--zoom-x', pointer.x + '%')
        imagezoom.style.setProperty('--zoom-y', pointer.y + '%')
    }
    
    zoomOutWhenMouseOut(e: any){ 
        const imagezoom = e.target.closest('.image-zoom-js')
    
        imagezoom.style.setProperty('--display', 'none')
    }
    
    activateZoom (imagezoom: any) {
        imagezoom.addEventListener('mousemove', this.zoomInWhenMouseMove, true)
        imagezoom.addEventListener('mouseout', this.zoomOutWhenMouseOut)
    }
    
    deactivateZoom (imagezoom: any) {
        imagezoom.removeEventListener("mousemove", this.zoomInWhenMouseMove, true)
        imagezoom.style.setProperty('--display', 'none')
    }
    
    initImageZoom () {
        const imageZooms = document.querySelectorAll('.image-zoom-js');
    
        if (!imageZooms ) { return }
    
        imageZooms.forEach((imagezoom) => {
            const toggle = document.createElement('button')
            toggle.className = 'image-zoom-js-toggle'
    
            toggle.addEventListener('click', () => {
                if (toggle.classList.contains('active')) {
                    toggle.classList.remove('active')
                    imagezoom.classList.remove('active')
                    this.deactivateZoom(imagezoom)
                } else {
                    toggle.classList.add('active')
                    imagezoom.classList.add('active')
                    this.activateZoom(imagezoom)
                }
            })
            imagezoom.appendChild(toggle)
        })
    }
}

export default ProductInfo
